module.exports = __webpack_public_path__ + "static/media/watch.b143ea19.png";